// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
; (function ($, window, document, undefined) {

    "use strict";

    // Create the defaults once
    var pluginName = "simpleCalendar",
        dataPlugin = "plugin_" + pluginName,
        defaults = {
            months: ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'July', 'Augustus', 'September', 'Oktober', 'November', 'December'], //string of months starting from january
            days: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'], //string of days starting from sunday
            displayYear: true, // display year in header
            fixedStartDay: true, // Week begin always by monday or by day set by number 0 = sunday, 7 = saturday, false = month always begin by first day of the month
            displayEvent: true, // display existing event
            disableEventDetails: false, // disable showing event details
            disableEmptyDetails: false, // disable showing empty date details
            events: [], // List of event
            onInit: function (calendar) { }, // Callback after first initialization
            onMonthChange: function (month, year) { }, // Callback on month change
            onDateSelect: function (date, events) { }, // Callback on date selection
            onEventSelect: function () { },              // Callback fired when an event is selected     - see $(this).data('event')
            onEventCreate: function ($el) { },          // Callback fired when an HTML event is created - see $(this).data('event')
            onDayCreate: function ($el, d, m, y) { }  // Callback fired when an HTML day is created   - see $(this).data('today'), .data('todayEvents')
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this._defaults = defaults;
        this._name = pluginName;
        this.currentDate = new Date();
        this.settings = $.extend({}, defaults, options);
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function (settings) {
            $.extend( this.settings, settings );

            var container = $(this.element);
            var todayDate = this.currentDate;

            var calendar = $('<div class="calendar"></div>');
            var header = $('<header>' + '<h2 class="month"></h2>' +'</header>');

            this.updateHeader(todayDate, header);
            calendar.append(header);

            this.buildCalendar(todayDate, calendar);
            container.append(calendar);

            this.bindEvents();
            this.settings.onInit(this);
        },

        //Update the current month header
        updateHeader: function (date, header) {
            var monthText = this.settings.months[date.getMonth()];
            monthText += this.settings.displayYear ? ' <span class="year">' + date.getFullYear() : '</span>';
            header.find('.month').html(monthText);
        },

        //Build calendar of a month from date
        buildCalendar: function (fromDate, calendar) {
            var plugin = this;

            calendar.find('table').remove();

            var body = $('<table></table>');
            var thead = $('<thead></thead>');
            var tbody = $('<tbody></tbody>');

            var y = fromDate.getFullYear(), m = fromDate.getMonth();
            var firstDay = new Date(y, m, 1);
            var lastDay = new Date(y, m + 1, 0);
            var startDayOfWeek = firstDay.getDay();

            if (this.settings.fixedStartDay !== false) {
                startDayOfWeek = this.settings.fixedStartDay ? 1 : this.settings.fixedStartDay;
                while (firstDay.getDay() !== startDayOfWeek) {
                    firstDay.setDate(firstDay.getDate() - 1);
                }
                while (lastDay.getDay() !== ((startDayOfWeek + 7) % 7)) {
                    lastDay.setDate(lastDay.getDate() + 1);
                }
            }

            //Header day in a week ( (x to x + 7) % 7 to start the week by monday if x = 1)
            for (var i = startDayOfWeek; i < startDayOfWeek + 7; i++) {
                thead.append($('<td>' + this.settings.days[i % 7].substring(0, 3) + '</td>'));
            }

            //For firstDay to lastDay
            for (var day = firstDay; day <= lastDay; day.setDate(day.getDate())) {
                var tr = $('<tr></tr>');
                //For each row
                for (var i = 0; i < 7; i++) {

                    var td = $('<td><div class="day" data-date="' + plugin.getFormattedDate(day) +'"><span class="day-nr">' + day.getDate() + '</span></div></td>');
                    var $day = td.find('.day');

                    //if today is this day
                    if (day.toDateString() === (new Date).toDateString()) {
                        $day.addClass("today");
                    }

                    //if day is not in this month
                    if (day.getMonth() != fromDate.getMonth()) {
                        td.addClass('other-month');
                    }

                    // filter today's events
                    var todayEvents = plugin.getDateEvents(day);
                    
                    if (todayEvents.length && plugin.settings.displayEvent) {
                        $day.addClass(plugin.settings.disableEventDetails ? "js-cal-event has-event disabled" : "js-cal-event has-event");
                        $day.attr('data-event-nr', todayEvents[0].eventNr)
                    } else {
                        $day.addClass(plugin.settings.disableEmptyDetails ? "disabled" : "");
                    }

                    tr.append(td);
                    day.setDate(day.getDate() + 1);
                }
                tbody.append(tr);
            }

            body.append(thead);
            body.append(tbody);
            calendar.append(body);
        },
        gotoDate: function (newDate) {
            this.currentDate = new Date(newDate);
            this.buildCalendar(this.currentDate, $(this.element).find('.calendar'));
            this.updateHeader(this.currentDate, $(this.element).find('.calendar header'));
            this.settings.onMonthChange(this.currentDate.getMonth(), this.currentDate.getFullYear())
        },
        changeMonth: function (value) {
            this.currentDate.setMonth(this.currentDate.getMonth() + value, 1);
            this.buildCalendar(this.currentDate, $(this.element).find('.calendar'));
            this.updateHeader(this.currentDate, $(this.element).find('.calendar header'));
            this.settings.onMonthChange(this.currentDate.getMonth(), this.currentDate.getFullYear())
        },
        getFormattedDate: function (date) {
            var formattedDate = date.getDate() + '-' + (date.getMonth()+1) + '-' + date.getFullYear();
            return formattedDate;
        },
        //Init global events listeners
        bindEvents: function () {
            var plugin = this;

            //Click previous month
            $(plugin.element).on('click', '.btn-prev', function (e) {
                plugin.changeMonth(-1)
                e.preventDefault();
            });

            //Click next month
            $(plugin.element).on('click', '.btn-next', function (e) {
                plugin.changeMonth(1);
                e.preventDefault();
            });
        },
        getDateEvents: function (day) {
            var plugin = this;
            return plugin.settings.events.filter(function (event) {
                return plugin.isSelectedDate(day, new Date(event.date));
            });
        },
        isSelectedDate: function (day, eventDate) {
            var plugin = this;
            return plugin.getFormattedDate(day) === plugin.getFormattedDate(eventDate);
        }
    });

    /*
        * Plugin wrapper, preventing against multiple instantiations and
        * allowing any public function to be called via the jQuery plugin,
        * e.g. $(element).pluginName('functionName', arg1, arg2, ...)
        */
    $.fn[pluginName] = function (arg) {
        var args, instance;
        if (!(this.data(dataPlugin) instanceof Plugin)) {
            this.data(dataPlugin, new Plugin(this));
        }
        instance = this.data(dataPlugin);
        instance.element = this;
        if (typeof arg === 'undefined' || typeof arg === 'object') {
            if (typeof instance['init'] === 'function') {
                instance.init(arg);
            }
        } else if (typeof arg === 'string' && typeof instance[arg] === 'function') {
            args = Array.prototype.slice.call(arguments, 1);
            return instance[arg].apply(instance, args);
        } else {
            $.error('Method ' + arg + ' does not exist on jQuery.' + pluginName);
        }
    };

})(jQuery, window, document);
